module.exports = __webpack_public_path__ + "static/assets/3b7e81fbb58e2d2e20d5946fd8aa2227.png";